/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 10/10/2023
 */
import React, { useState } from "react"
import "./IconUpload.styles.scss"
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto"
import { IconButton, Tooltip } from "@mui/material"
import IconSelectionModal from "./IconSelectionModal"
import DynamicIcon from "../../../base/utils/DynamicIcon"

const IconUpload = ({ tooltip, grpIcon, setgrpIcon, onChange }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleUploadButtonClick = () => {
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleIconSelect = (iconName, iconKey) => {
    const selectedIcon = { target: { name: "icon", value: iconName } }
    console.log(iconName)
    setgrpIcon(iconName)
    handleCloseDialog()
    onChange(selectedIcon)
  }

  return (
    <div className="imageUploader">
      {grpIcon.type ? (
        <grpIcon.type className="icon-pic" sx={{ fontSize: "100px" }} />
      ) : (
        <DynamicIcon
          style={{
            width: "100px",
            maxHeight: "100px",
            padding: "5px",
            background: "#ddd",
            border: "2px solid #000",
            borderRadius: "100%",
            display: "inline-block",
            fontSize: "100px",
          }}
          iconName={grpIcon}
        />
      )}
      <div className="p-image">
        <Tooltip arrow placement="right" title={tooltip}>
          <IconButton
            className="select-button"
            onClick={handleUploadButtonClick}>
            <AddAPhotoIcon />
          </IconButton>
        </Tooltip>
        <IconSelectionModal
          open={dialogOpen}
          handleClose={handleCloseDialog}
          handleIconSelect={handleIconSelect}
        />
      </div>
    </div>
  )
}

export default IconUpload
